export * from './lib/endpoints';
export { environment as operatorEnv } from './lib/environments/operator/environment';
export { environment as merchantEnv } from './lib/environments/merchant/environment';
export { environment as courierEnv } from './lib/environments/courier/environment';
export { AvailableAppsEndpoints as OperatorAvailableApi } from './lib/environments/operator/environment.constants';
export { AvailableAppsEndpoints as MerchantAvailableApi } from './lib/environments/merchant/environment.constants';
export { ApiEndpoints } from './lib/environments/evironment.interface';
export { getImagesEndpoint, getApiEndpoint, getBuyerEndpoint } from './lib/environments/endpoint';
export { RunTimeConfig, setRunTimeConfig, getRuntimeConfig } from './lib/run-time-config';
